// @flow
import * as React from "react"
import {Route, Switch} from "react-router-dom"
import * as Util from "../common"
import CombatForm from "./CombatForm"
import CombatMain from "./CombatMain"

export default function CombatRouter({readonly, match}: Object) {
  return (
    <Switch>
      <Route
        exact
        path={match.path + ""}
        render={props => <CombatForm {...{props, readonly, match}} />}
      />
      <Route exact path={match.path + "/run"} component={CombatMain} />
      <Route component={Util.NotFoundView} />
    </Switch>
  )
}



// WEBPACK FOOTER //
// ./src/combat/CombatRouter.js